import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { ClaimPermissions } from '@app/enums';
import { PermissionSiteClaimEditModel } from '@app/models/system-settings/permissions.model';

/** Radio-group value representing "No Access"; written to ClaimValue as null. */
const NO_ACCESS = '';

interface PermissionOption {
	label: string;
	value: string;
	isVisible: (claim: PermissionSiteClaimEditModel) => boolean;
}

@Component({
	selector: 'sb-role-site-claim-permissions',
	standalone: true,
	imports: [MatRadioModule],
	templateUrl: './role-site-claim-permissions.component.html',
	styleUrl: './role-site-claim-permissions.component.less',
})
export class RoleSiteClaimPermissionsComponent {
	/** Claims to display. Their `ClaimValue` is edited in place. */
	@Input({ required: true }) claims: PermissionSiteClaimEditModel[] = [];

	/** Displays the values without allowing changes. */
	@Input() readOnly = false;

	/** Emits (without a payload) after one or more `ClaimValue`s have changed. */
	@Output() changed = new EventEmitter<void>();

	readonly options: PermissionOption[] = [
		{ label: 'No Access', value: NO_ACCESS, isVisible: () => true },
		{ label: 'Read Only', value: ClaimPermissions.ReadOnly, isVisible: (claim) => claim.ReadOnly },
		{ label: 'View / Edit', value: ClaimPermissions.ViewEdit, isVisible: (claim) => claim.ViewEdit },
	];

	selectedValue(claim: PermissionSiteClaimEditModel): string {
		return claim.ClaimValue || NO_ACCESS;
	}

	onValueChange(claim: PermissionSiteClaimEditModel, value: string): void {
		claim.ClaimValue = value || null;
		this.changed.emit();
	}

	selectAll(option: PermissionOption): void {
		const newValue = option.value || null;
		const rowsToChange = this.claims.filter(
			(claim) => option.isVisible(claim) && (claim.ClaimValue || null) !== newValue
		);
		if (!rowsToChange.length) {
			return;
		}
		rowsToChange.forEach((claim) => (claim.ClaimValue = newValue));
		this.changed.emit();
	}
}
